<fury-page-layout mode="card">
  <fury-page-layout-header>
    <fury-breadcrumbs [@fadeInRight] current="Charge Copay"></fury-breadcrumbs>
  </fury-page-layout-header>

  <fury-page-layout-content [@fadeInUp]>
    <fury-list
      name="Charge Copay"
      [columns]="columns"
      (filterChange)="onFilterChange($event)"
    >
      <div style="position: relative" class="filter">
        <button
          class="filter fury-column-filter"
          type="button"
          mat-icon-button
          (click)="showFilter()"
        >
          <img src="../../../assets/img/filter.png" alt="filter" />
        </button>
        <div class="filteringprt" *ngIf="isShowFilter">
          <form [formGroup]="filterForm">
            <h3 style="margin: 0">Filter</h3>
            <mat-form-field appearance="outline">
              <mat-label>Search By</mat-label>
              <mat-select formControlName="searchBy">
                <mat-option
                  *ngFor="let item of searchByValue"
                  [value]="item?.value"
                  >{{ item.title }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Search Type</mat-label>
              <mat-select formControlName="searchType">
                <mat-option
                  *ngFor="let item of commonService.searchTypeValue"
                  [value]="item?.value"
                  >{{ item.title }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <div class="btnprt">
              <button mat-button class="can-button" (click)="showFilter()">
                Cancel
              </button>
              <button mat-button class="sub-button" (click)="filterChange()">
                Search
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="actions">
        <button
          class="create"
          type="button"
          mat-raised-button
          color="primary"
          (click)="addCopayModal()"
        >
          Charge Copay
        </button>
      </div>
      <div class="table_container">
        <table [dataSource]="dataSource" mat-table>
          <ng-container matColumnDef="claimNumber">
            <th mat-header-cell *matHeaderCellDef>Claim Number</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.claimNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef>Full Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.firstName }} {{ element?.lastName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="phoneNumber">
            <th mat-header-cell *matHeaderCellDef>Phone Number</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.phoneNumber | mask : "(000) 000-0000" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="emailAddress">
            <th mat-header-cell *matHeaderCellDef>Email Address</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.emailAddress }}
            </td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>Address</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.billingAddress?.streetAddress }}
            </td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef>City</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.billingAddress?.city }}
            </td>
          </ng-container>
          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>State</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.billingAddress?.state }}
            </td>
          </ng-container>
          <ng-container matColumnDef="zip">
            <th mat-header-cell *matHeaderCellDef>Zip</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.billingAddress?.zip }}
            </td>
          </ng-container>
          <ng-container matColumnDef="copayAmount">
            <th mat-header-cell *matHeaderCellDef>Copay Amount</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.copayAmount | currency }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cardNumber">
            <th mat-header-cell *matHeaderCellDef>Card (last four digits)</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.lastFourDigit }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cardType">
            <th mat-header-cell *matHeaderCellDef>Card Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.cardType }}
            </td>
          </ng-container>
  
          <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
          <tr
            *matRowDef="let row; columns: visibleColumns"
            class="clickable route-animations-elements"
            mat-row
          ></tr>
        </table>
      </div>
     
      <div
        *ngIf="itemList?.length === 0"
        style="padding: 10px 0; text-align: center"
      >
        No data found.
      </div>
      <mat-paginator
        [pageSizeOptions]="[30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </fury-list>
  </fury-page-layout-content>
</fury-page-layout>
